import React from 'react';
import appNavigationNames, { withActiveTab } from '../../utils/appNavigationNames';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { getIntl } from '../../utils/intl';
import { screens } from '../screens/Tabs/Activity';
import { MaybeDrawerLayout } from '../shared/MaybeSideNavLayout';
import { getHeader, mobileHeaderConfigs } from '../v2BaseComponents/Header';
import { colors } from '../../utils/theme';
import { useCapturedUrlUTMParameters } from '../../hooks/useUrlUTMParameters';

const intl = getIntl('activity-navigator', {
    auditLogDetails: 'Activity Details',
    root: 'Activity',
    addMessage: 'Add Message',
});

const Stack = createNativeStackNavigator();

const ActivityNavigatorNavigation = () => {
    const capturedUrlUTMParameters = useCapturedUrlUTMParameters();

    return (
        <MaybeDrawerLayout>
            <Stack.Navigator initialRouteName={appNavigationNames.activity.root}>
                <Stack.Screen
                    options={{
                        header: getHeader({ mobile: mobileHeaderConfigs.logo, breadCrumbs: ['activity-root'] }),
                        title: intl('root'),
                        contentStyle: {
                            backgroundColor: colors.Background,
                        },
                    }}
                    name={appNavigationNames.activity.root}
                    component={screens.ActivityScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('auditLogDetails'),
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['activity-root', 'audit-log'],
                        }),
                    }}
                    name={appNavigationNames.activity.auditLogDetails}
                    component={screens.AuditLogDetailsScreen}
                    initialParams={capturedUrlUTMParameters}
                />
                <Stack.Screen
                    options={{
                        title: intl('auditLogDetails'),
                        header: getHeader({
                            mobile: mobileHeaderConfigs.standard,
                            breadCrumbs: ['activity-root', 'add-message'],
                        }),
                    }}
                    name={appNavigationNames.activity.addMessage}
                    component={screens.AddMessageScreen}
                    initialParams={capturedUrlUTMParameters}
                />
            </Stack.Navigator>
        </MaybeDrawerLayout>
    );
};

export default withActiveTab(ActivityNavigatorNavigation, 'activity');
